import { gql } from '@apollo/client';

export const GET_PORTAL_PROGRAMMES_REPORTERS = gql`
  query GetPortalProgrammesReporters($input: GetPortalProgrammesReportersArgs!) {
    organisations: getPortalProgrammesReporters(input: $input) {
      id
      funder {
        id
        name
      }
      serviceProvider {
        id
        name
      }
      institution {
        id
        name
      }
    }
  }
`;
